import React from 'react'

import {
  Button,
  IconArrowLeftDefault,
  IconArrowRightDefault,
} from '@mc/design-system'
import { useTranslation } from '@mc/i18n'

export const Pagination = ({
  currentPage,
  changePage,
  totalPages,
}: {
  currentPage: number
  changePage: React.Dispatch<React.SetStateAction<number>>
  totalPages: number
}) => {
  const { t } = useTranslation('@mc/next')

  return (
    <nav className='mc-text-h7 mc-text--center'>
      {currentPage > 1 && (
        <>
          <Button
            aria-label={t('articles.pagination.previous')}
            className='mc-px-2 mc-mx-2'
            kind='control'
            size='small'
            onClick={() =>
              changePage((currentState) => {
                if (currentState === 1) return 1
                return currentState - 1
              })
            }
          >
            <IconArrowLeftDefault />
          </Button>
          <Button
            className='mc-px-2 mc-mx-2'
            kind='control'
            size='small'
            onClick={() => changePage(1)}
          >
            {'1'}
          </Button>
        </>
      )}

      {currentPage > 2 && (
        <>
          {currentPage >= 4 && <span>{t('articles.pagination.ellipsis')}</span>}
          <Button
            className='mc-px-2 mc-mx-2'
            kind='control'
            size='small'
            onClick={() => changePage((currentState) => currentState - 1)}
          >
            {currentPage - 1}
          </Button>
        </>
      )}

      <span className='mc-px-2 mc-mx-2 mc-corners--rounded'>{currentPage}</span>

      {currentPage < totalPages - 1 && (
        <>
          <Button
            className='mc-px-2 mc-mx-2'
            kind='control'
            size='small'
            onClick={() => changePage((currentState) => currentState + 1)}
          >
            {currentPage + 1}
          </Button>
          {currentPage <= totalPages - 3 && (
            <span>{t('articles.pagination.ellipsis')}</span>
          )}
        </>
      )}

      {currentPage < totalPages && (
        <>
          <Button
            className='mc-px-2 mc-mx-2'
            kind='control'
            size='small'
            onClick={() => changePage(totalPages)}
          >
            {totalPages}
          </Button>
          <Button
            aria-label={t('articles.pagination.next')}
            className='mc-px-2 mc-mx-2'
            kind='control'
            size='small'
            onClick={() => changePage((currentState) => currentState + 1)}
          >
            <IconArrowRightDefault />
          </Button>
        </>
      )}
    </nav>
  )
}
